import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {
  static values = {
    tags: String,
  };

  connect() {
    this.select = new TomSelect(this.element, {
      plugins: ['remove_button'],
      create: true,
      onItemAdd: function () {
        //ios 폰에서 아이테 추가할 때 마지막에 추가한 아이템의 마지막 글자가 다시 입력되는 버그를 대응
        this.blur();
      },
      render: {
        option_create: function (data, escape) {
          return '<div class="create"><strong>' + escape(data.input) + '</strong> 추가 &hellip;</div>';
        },
        no_results: function (data, escape) {
          return '<div class="no-results">해시태그를 입력해 주세요.</div>';
        },
      },
    });
  }
}
